import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import routes from '../routes/routes'
import alertService from '../services/alert.service'
import userApi, { UserUpdatePasswordRequest } from '../apis/user.api'
import AuthCard from '../components/AuthCard'
import Button from '../components/Button'
import InputText from '../components/InputText'
import Page from '../components/Page'

interface MatchParams {
  token: string
}

interface Props extends RouteComponentProps<MatchParams> {}

interface State {
  newPassword: string
  confirmPassword: string
}

class UpdatePassword extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      newPassword: '',
      confirmPassword: '',
    }
  }

  handleInputChange = (name: string, value: string) => {
    if (name === 'newPassword') this.setState({ newPassword: value })
    else if (name === 'confirmPassword') {
      this.setState({ confirmPassword: value })
    }
  }

  handleUpdatePasswordClick = () => {
    const { token } = this.props.match.params
    const { newPassword, confirmPassword } = this.state
    const payload: UserUpdatePasswordRequest = { }
    if (token) payload.token = token
    if (newPassword) payload.newPassword = newPassword
    if (confirmPassword) payload.confirmPassword = confirmPassword
    userApi.updatePassword(payload, result => {
      if (!result || !result.updated) return
      const message = 'Password has been successfully updated'
      alertService.success(message)
      this.props.history.push(routes.signIn)
    })
  }

  render () {
    return (
      <Page size='half' wrapperClass="pt-20">
        <AuthCard
          heading='Update password'
          description='Update your QPRO+ password'>
          <InputText
            label={i18n("New password")}
            type="password"
            name="newPassword"
            value={this.state.newPassword}
            onChange={this.handleInputChange} />
          <InputText
            label={i18n("Confirm password")}
            type="password"
            name="confirmPassword"
            value={this.state.confirmPassword}
            onChange={this.handleInputChange} />
          <Button
            text={i18n("Update password")}
            full={true}
            onClick={this.handleUpdatePasswordClick} />
        </AuthCard>
      </Page>
    )
  }
}

export default withRouter(UpdatePassword)
